module.exports = __webpack_public_path__ + "static/media/icon-aluguel-lifestyle.3c986f2c.webp";